// Appointments ka data: asli API (GET /pounce/appointments), ya UI dikhane ke
// liye neeche ki nakli list.
//
// Asli rows ki shape server pe banti hai (pounceAppointments.js → toAppointment)
// aur wahi hai jo nakli list ki hai — isliye pages ko farq nahi padta.
import { getPounceAppointments } from "../../Store/apiStore";
import { addDays, startOfWeek } from "./appointmentHelpers";

// true = nakli appointments (design/demo ke liye). false = asli API.
export const USE_STATIC_APPOINTMENTS = false;

// Nakli data turant mil jaata, to loader kabhi dikhta hi nahi.
const STATIC_DELAY_MS = 600;

// Is hafte ke Monday se `day` din aage, `h:m` baje — taaki list hamesha
// "This week" me bhari dikhe, chahe page kisi bhi tareekh ko khule.
const at = (day, h, m = 0) => {
  const d = addDays(startOfWeek(new Date()), day);
  d.setHours(h, m, 0, 0);
  return d.toISOString();
};

const buildStatic = () => [
  {
    id: "static-appt-1",
    status: "upcoming",
    title: "Rexpt Demo Call",
    type: "video",
    startTime: at(1, 14, 0),
    durationMin: 30,
    timezone: "EDT",
    provider: "Google Calendar",
    bookedByPounce: true,
    lead: {
      name: "Marcus Vance",
      source: "Google Lead Ads",
      phone: "+1 (555) 714-2901",
      email: "marcus.v@acme.com",
      company: "Acme Technologies, Inc.",
    },
    qualification: {
      summary: "Interested in inbound lead automation. Budget approved. Requested demo this week.",
      items: [
        { label: "Service needed", value: "Inbound AI receptionist" },
        { label: "Team size", value: "5 – 10 reps" },
        { label: "Budget", value: "Approved" },
      ],
    },
    activity: [
      { title: "Lead received", detail: "From Google Lead Ads", at: at(0, 10, 24) },
      { title: "First contact in 8.2 sec", detail: "AI called the lead automatically", at: at(0, 10, 24) },
      { title: "Qualified by Outbound Caller", detail: "Lead met qualification criteria", at: at(0, 10, 25) },
      { title: "Appointment booked", detail: "Rexpt Demo Call (30 min)", at: at(0, 10, 26), done: true },
    ],
  },
  {
    id: "static-appt-2",
    status: "upcoming",
    title: "Consultation Call",
    type: "phone",
    startTime: at(4, 11, 30),
    durationMin: 30,
    timezone: "EDT",
    provider: "Google Calendar",
    bookedByPounce: true,
    lead: {
      name: "Elena Rostova",
      source: "Website Form",
      phone: "+1 (555) 203-8844",
      email: "elena@northwinddental.com",
      company: "Northwind Dental Group",
    },
    qualification: {
      summary: "Wants after-hours call coverage for two locations. Decision-maker on the call.",
      items: [
        { label: "Service needed", value: "After-hours answering" },
        { label: "Timeline", value: "Within 1-2 weeks" },
      ],
    },
    activity: [
      { title: "Lead received", detail: "From Website Form", at: at(0, 15, 2) },
      { title: "First contact in 6.9 sec", detail: "AI called the lead automatically", at: at(0, 15, 2) },
      { title: "Appointment booked", detail: "Consultation Call (30 min)", at: at(0, 15, 5), done: true },
    ],
  },
  {
    id: "static-appt-3",
    status: "upcoming",
    rescheduled: true,
    title: "HVAC Quote Review",
    type: "doc",
    startTime: at(5, 16, 0),
    durationMin: 45,
    timezone: "EDT",
    provider: "Google Calendar",
    bookedByPounce: true,
    lead: {
      name: "James Carter",
      source: "Manual Add",
      phone: "+1 (555) 660-1173",
      email: "james@brightlineroofing.com",
      company: "Brightline Roofing",
    },
    activity: [
      { title: "Lead added manually", detail: "By your team", at: at(0, 9, 12) },
      { title: "Appointment booked", detail: "HVAC Quote Review (45 min)", at: at(0, 9, 20) },
      { title: "Rescheduled by lead", detail: "Moved to a later slot", at: at(1, 12, 40), done: true },
    ],
  },
  {
    id: "static-appt-4",
    status: "completed",
    title: "Discovery Call",
    type: "phone",
    startTime: at(0, 9, 30),
    durationMin: 30,
    timezone: "EDT",
    provider: "Google Calendar",
    bookedByPounce: true,
    lead: { name: "Sarah Lee", source: "CRM", phone: "+1 (555) 482-0096", email: "sarah.lee@lumenrealty.com" },
  },
  {
    id: "static-appt-5",
    status: "completed",
    title: "Intro Call",
    type: "video",
    startTime: at(0, 15, 0),
    durationMin: 20,
    timezone: "EDT",
    provider: "Google Calendar",
    bookedByPounce: true,
    lead: { name: "Robert Wilson", source: "Web Form", phone: "+1 (555) 318-7742" },
  },
  {
    id: "static-appt-6",
    status: "completed",
    title: "Product Walkthrough",
    type: "doc",
    startTime: at(1, 13, 15),
    durationMin: 30,
    timezone: "EDT",
    provider: "Google Calendar",
    bookedByPounce: true,
    lead: { name: "Emily Carter", source: "CRM", email: "emily.carter@example.com" },
  },
  {
    id: "static-appt-7",
    status: "cancelled",
    cancelledBy: "lead",
    cancelReason: "Lead had a scheduling conflict.",
    title: "Sales Consultation",
    type: "phone",
    startTime: at(2, 10, 0),
    durationMin: 30,
    timezone: "EDT",
    provider: "Google Calendar",
    bookedByPounce: true,
    lead: { name: "Michael Davis", source: "Facebook Lead", phone: "+1 (555) 901-2267" },
  },
  {
    id: "static-appt-8",
    status: "cancelled",
    cancelledBy: "business",
    cancelReason: "We needed to reschedule due to internal changes.",
    title: "Follow-up Call",
    type: "video",
    startTime: at(3, 17, 30),
    durationMin: 30,
    timezone: "EDT",
    provider: "Google Calendar",
    bookedByPounce: true,
    lead: { name: "Jessica Brown", source: "Manual Add", email: "jessica.brown@example.com" },
  },
];

const delayed = (value) =>
  new Promise((resolve) => setTimeout(() => resolve(value), STATIC_DELAY_MS));

// `agentId` = jis Pounce agent ki appointments chahiye.
export const fetchPounceAppointments = (agentId) =>
  USE_STATIC_APPOINTMENTS ? delayed(buildStatic()) : getPounceAppointments(agentId);

export const fetchPounceAppointment = (id, agentId) =>
  fetchPounceAppointments(agentId).then(
    (rows) => rows.find((row) => String(row.id) === String(id)) || null,
  );
